import * as storage from '../utilities/storage';
import { SYNC_TIME } from '../constants/storage';

/**
 * Get sync time from storage.
 *
 * @returns {string}
 */
export function getSyncTime() {
  return storage.get(SYNC_TIME);
}

/**
 * Set sync time to storage.
 *
 * @param {string} timestamp
 */
export function setSyncTime(timestamp) {
  storage.set(SYNC_TIME, timestamp);
}

/**
 * Clear sync time.
 */
export function clearSnapshot() {
  storage.remove(SYNC_TIME);
}
